import { useAuth } from "../context/AuthContext";
import PeriodBar from "../components/PeriodBar";
import NetworkDashboard from "../components/NetworkDashboard";
import StoreDashboard from "../components/StoreDashboard";

export default function Dashboard() {
  const { user, storeId } = useAuth();
  return (
    <>
      <PeriodBar />
      {user.role === "admin" && (storeId === "all" || !storeId) ? <NetworkDashboard /> : <StoreDashboard storeId={storeId} key={storeId} />}
    </>
  );
}
